import React, { Component } from 'react';
interface Product {
  name: string;
  badge: string;
  badgeColor: string;
  image: string;
  href: string;
}
const products: Product[] = [{
  name: 'MEX15 (Oil)',
  badge: 'Ultra-precision machine',
  badgeColor: 'bg-[#D4A843]',
  image: 'https://seibu-america.com/assets/img/product/product08.png',
  href: 'https://seibu-america.com/products/mex15/'
}, {
  name: 'M25LP',
  badge: 'Ultra-precision machine',
  badgeColor: 'bg-[#D4A843]',
  image: 'https://seibu-america.com/assets/img/product/product09.png',
  href: 'https://seibu-america.com/products/m25lp/'
}];
export function OilSpecificationSection() {
  return <section data-id="element-3661">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3662">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-3663">
          Oil Specification Wire EDM
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-3664">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-3665">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-3666">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block relative" data-id="element-3667">
                <span className={`absolute top-3 left-3 ${product.badgeColor} text-white px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider shadow-sm z-10`} data-id="element-3668">
                  {product.badge}
                </span>
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-3669" />
              </a>

              <div className="p-5 flex flex-col flex-grow" data-id="element-3670">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-3671">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-3672">
                    {product.name}
                  </h3>
                </a>

                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-3673">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent('Seibu ' + product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-3674">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-3675">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}